import { createSlice } from '@reduxjs/toolkit';

const examSlice = createSlice({
  name: 'exam',
  initialState: { currentExam: null, sessionId: null },
  reducers: {
    setCurrentExam(state, action) { state.currentExam = action.payload; },
    setSessionId(state, action) { state.sessionId = action.payload; },
    clearExam(state) { state.currentExam = null; state.sessionId = null; },
  },
});

export const { setCurrentExam, setSessionId, clearExam } = examSlice.actions;
export default examSlice.reducer;
